import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { Column, RowData } from '../tanstack-table';

/**
 * Which columns table settings lists, from its search. With column categories it lists only the
 * shown columns, and a search also finds hidden ones so one can be ticked back.
 */
export const useListedColumns = t0 => {
  const $ = _c(30);
  const {
    columns,
    columnVisibility,
    getLabel
  } = t0;
  const [search, setSearch] = useState("");
  let t1;
  if ($[0] !== search) {
    t1 = search.trim();
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isSearchActive = t1.length > 0;
  let isListed;
  let isShown;
  let listsShownOnly;
  let t2;
  if ($[2] !== columnVisibility || $[3] !== columns || $[4] !== getLabel || $[5] !== isSearchActive || $[6] !== search) {
    const normalizedSearch = search.trim().toLocaleLowerCase();
    let t3;
    if ($[11] !== columns) {
      t3 = columns.some(_temp);
      $[11] = columns;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    listsShownOnly = t3;
    let t4;
    if ($[13] !== columnVisibility) {
      t4 = column_0 => columnVisibility[column_0.id] ?? column_0.getIsVisible();
      $[13] = columnVisibility;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    isShown = t4;
    let t5;
    if ($[15] !== isSearchActive || $[16] !== isShown || $[17] !== listsShownOnly) {
      t5 = column_1 => !listsShownOnly || isSearchActive || isShown(column_1);
      $[15] = isSearchActive;
      $[16] = isShown;
      $[17] = listsShownOnly;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    isListed = t5;
    t2 = new Set(columns.filter(column_2 => getLabel(column_2).toLocaleLowerCase().includes(normalizedSearch)).map(_temp2));
    $[2] = columnVisibility;
    $[3] = columns;
    $[4] = getLabel;
    $[5] = isSearchActive;
    $[6] = search;
    $[7] = isListed;
    $[8] = isShown;
    $[9] = listsShownOnly;
    $[10] = t2;
  } else {
    isListed = $[7];
    isShown = $[8];
    listsShownOnly = $[9];
    t2 = $[10];
  }
  const matchingColumnIds = t2;
  const resultLabel = matchingColumnIds.size === 1 ? "column" : "columns";
  let t3;
  if ($[19] !== columns || $[20] !== isShown || $[21] !== listsShownOnly) {
    t3 = listsShownOnly ? `${columns.filter(isShown).length} of ${columns.length} columns shown` : `${columns.length} columns`;
    $[19] = columns;
    $[20] = isShown;
    $[21] = listsShownOnly;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  const columnCount = t3;
  const t4 = isSearchActive ? `${matchingColumnIds.size} ${resultLabel} found` : columnCount;
  let t5;
  if ($[23] !== isListed || $[24] !== isSearchActive || $[25] !== listsShownOnly || $[26] !== matchingColumnIds || $[27] !== search || $[28] !== t4) {
    t5 = {
      isListed,
      isSearchActive,
      listsShownOnly,
      matchingColumnIds,
      search,
      searchResultMessage: t4,
      setSearch
    };
    $[23] = isListed;
    $[24] = isSearchActive;
    $[25] = listsShownOnly;
    $[26] = matchingColumnIds;
    $[27] = search;
    $[28] = t4;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  return t5;
};
function _temp(column) {
  return column.columnDef.meta?.group;
}
function _temp2(column_3) {
  return column_3.id;
}